import { FC } from "react";

export const CookieLogoIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <g clip-path="url(#clip0_4317_42390)">
        <path
          d="M20.9191 12.1932C20.2514 11.6681 16.5635 12.3862 15.4647 11.9202C14.6926 11.5933 15.3742 9.47725 14.9152 9.15558L12.3384 8.86347C11.7263 8.33489 12.4844 4.09755 12.0358 3.33946C11.8933 3.09777 11.436 3.02126 11.1682 2.98997C10.2814 2.88912 7.85066 2.86999 6.98302 2.98475C5.30686 3.20383 6.44227 5.47638 5.8737 5.87456C5.10691 6.1458 3.57507 5.56332 3.17168 6.47617C2.8813 7.13341 3.3299 8.40096 2.91086 8.82348C2.29361 9.44769 0.43314 8.61657 0.160156 9.55028V17.4773C0.500952 18.6544 2.65701 17.7867 3.00476 18.2858C2.98389 21.0417 3.11604 21.1773 5.8737 21.1547C6.37272 21.5025 5.50334 23.6585 6.68222 23.9976L14.7309 23.9489C15.4664 23.5907 14.7344 21.8415 15.3342 21.2486C15.7568 20.8296 17.0243 21.2782 17.6816 20.9878C18.5944 20.5844 18.0102 19.0526 18.2832 18.2858C18.6309 17.7867 20.787 18.6561 21.126 17.4773C21.2634 16.9974 21.253 13.4329 21.1712 12.8122C21.1399 12.5688 21.1313 12.3618 20.9191 12.1949V12.1932ZM17.9459 17.6007C17.5268 18.4614 15.3169 17.3138 15.0804 18.5605C15.0004 18.9865 15.2856 20.9026 14.6405 20.9026H6.38141L6.05105 18.1901C5.65288 17.6859 4.16624 18.0823 3.53681 17.9224L3.276 17.6616L3.25687 9.69286C3.48465 8.48095 5.5103 9.51898 6.05105 8.83565C6.50139 8.2636 5.87718 6.7335 6.4527 6.28143L8.81914 6.21014C9.40684 6.55789 9.05909 8.26534 9.1895 8.8826C9.89891 9.28077 10.7996 8.95041 11.5125 9.08082C12.6183 9.28251 11.7924 11.6177 12.2845 11.9602C12.9104 12.2019 14.6283 11.7637 14.9917 12.3827C15.3047 12.913 14.8144 14.6205 15.2404 14.9161C17.6416 14.9995 18.4866 14.7909 17.9476 17.6007H17.9459Z"
          fill="black"
        />
        <path
          d="M20.9462 2.95332C21.2661 2.63339 21.2748 0.581663 20.9462 0.253039C20.6071 -0.0860182 18.7554 -0.0477656 18.2755 0.19566C17.8408 0.536455 18.0234 2.24913 18.1173 2.82291C18.4198 3.33411 20.4281 3.27151 20.9462 2.95332Z"
          fill="black"
        />
        <path
          d="M23.9548 6.37412C23.6261 5.82294 22.183 5.82989 21.6335 5.98638C20.7172 6.24893 20.8893 8.10766 21.1449 8.83619C21.4701 9.24828 23.3549 9.14917 23.873 8.92313C24.2695 8.6119 24.2051 6.79664 23.953 6.37412H23.9548Z"
          fill="black"
        />
        <path
          d="M18.6404 7.34088C18.7795 7.05573 18.7917 5.52563 18.7274 5.1657C18.55 4.192 15.7715 4.44934 15.7715 4.99183V7.51302C16.3957 7.68863 18.3414 7.95466 18.6404 7.33914V7.34088Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4317_42390">
          <rect
            width="24"
            height="23.9896"
            fill="white"
            transform="translate(0.158203 0.00585938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
